(function () {
  'use strict';


  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Text fade-in up on scroll ────────────────────────────────────────────
     Usage: add data-kb-fade to any element.
     Optional: data-kb-delay="200" (ms) for stagger.
  ─────────────────────────────────────────────────────────────────────────── */
  function initFadeIn() {
    var els = document.querySelectorAll('[data-kb-fade]');
    if (!els.length) return;

    if (reducedMotion) {
      els.forEach(function (el) { el.classList.add('kb-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.dataset.kbDelay || 0, 10);
        setTimeout(function () {
          entry.target.classList.add('kb-visible');
        }, delay);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.15 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── Number count-up ──────────────────────────────────────────────────────
     Usage: add data-kb-count="86" to the span. It starts at 0 and counts up
     to the target value when scrolled into view.
  ─────────────────────────────────────────────────────────────────────────── */
  function initCountUp() {
    var els = document.querySelectorAll('[data-kb-count]');
    if (!els.length) return;

    if (reducedMotion) {
      els.forEach(function (el) { el.textContent = el.dataset.kbCount; });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        runCount(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.3 });

    els.forEach(function (el) { observer.observe(el); });
  }

  function runCount(el) {
    var target   = parseFloat(el.dataset.kbCount);
    var duration = 1800;
    var start    = null;

    function step(ts) {
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var eased    = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      el.textContent = Math.round(eased * target);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  /* ── Vertical fill reveal — images only ──────────────────────────────────
     Usage: add data-kb-reveal-img to any img element.
     Reveals from bottom to top using clip-path on scroll.
  ─────────────────────────────────────────────────────────────────────────── */
  function initRevealImg() {
    var els = document.querySelectorAll('[data-kb-reveal-img]');
    if (!els.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      // No animation: leave images in default visible state
      return;
    }

    // Opt into animation: hide images now that JS is ready to reveal them
    els.forEach(function (el) { el.classList.add('kb-reveal-ready'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var delay = parseInt(entry.target.dataset.kbDelay || 0, 10);
        setTimeout(function () {
          entry.target.classList.add('kb-visible');
        }, delay);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });

    els.forEach(function (el) { observer.observe(el); });
  }

  /* ── Header CTA theme switcher ────────────────────────────────────────────
     Watches which section is behind the fixed CTA and toggles
     .is-on-light / .is-on-dark on the CTA element.
     Sections declare their theme via data-kb-header-theme="light|dark".
     Horizon sections without the attribute fall back to a known-ID map.
  ─────────────────────────────────────────────────────────────────────────── */
  function initHeaderTheme() {
    var cta = document.querySelector('.kb-header__cta');
    if (!cta) return;

    // Sections without data-kb-header-theme: infer by partial section ID
    var horizonDark  = ['hero_', 'password'];
    var horizonLight = ['trust_bar', 'benefits', 'carousel_', 'section_ii', 'footer'];

    function themeForEl(el) {
      if (el.dataset.kbHeaderTheme) return el.dataset.kbHeaderTheme;
      // Also check direct child — kb-* sections set the attribute on their inner element
      var child = el.firstElementChild;
      if (child && child.dataset.kbHeaderTheme) return child.dataset.kbHeaderTheme;
      var id = el.id || '';
      for (var i = 0; i < horizonDark.length; i++) {
        if (id.indexOf(horizonDark[i]) !== -1) return 'dark';
      }
      for (var j = 0; j < horizonLight.length; j++) {
        if (id.indexOf(horizonLight[j]) !== -1) return 'light';
      }
      return null; // unknown — don't change
    }

    function update() {
      var ctaRect = cta.getBoundingClientRect();
      var checkY  = ctaRect.top + ctaRect.height / 2;
      var found   = 'dark'; // safe default (white CTA shows on dark)

      // Walk the Shopify section wrappers from bottom to top
      var wrappers = document.querySelectorAll('.shopify-section, [data-kb-header-theme]');
      wrappers.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top <= checkY && r.bottom > checkY) {
          var t = themeForEl(el);
          if (t) found = t;
        }
      });

      cta.classList.toggle('is-on-light', found === 'light');
      cta.classList.toggle('is-on-dark',  found === 'dark');
    }

    window.addEventListener('scroll', update, { passive: true });
    update(); // run once on load
  }

/* ── Mobile sticky CTA idle-hide ─────────────────────────────────────────
     On mobile, hides the CTA after 5 s of inactivity and shows it again on
     any scroll/touch/key interaction. No-ops entirely on desktop.
  ─────────────────────────────────────────────────────────────────────────── */
  function initMobileStickyCtaIdle() {
    var cta = document.querySelector('.kb-header__cta');
    if (!cta) return;

    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var idleTimer   = null;
    var idleDelay   = 5000;

    function hideCta() {
      if (!mobileQuery.matches) return;
      cta.classList.add('is-idle-hidden');
    }

    function showCta() {
      cta.classList.remove('is-idle-hidden');
      clearTimeout(idleTimer);
      if (mobileQuery.matches) {
        idleTimer = setTimeout(hideCta, idleDelay);
      }
    }

    function handleActivity() {
      if (!mobileQuery.matches) {
        cta.classList.remove('is-idle-hidden');
        clearTimeout(idleTimer);
        return;
      }
      showCta();
    }

    function handleBreakpointChange() {
      cta.classList.remove('is-idle-hidden');
      clearTimeout(idleTimer);
      if (mobileQuery.matches) showCta();
    }

    ['scroll', 'touchstart', 'touchmove', 'pointerdown'].forEach(function (ev) {
      window.addEventListener(ev, handleActivity, { passive: true });
    });
    window.addEventListener('keydown', handleActivity);

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', handleBreakpointChange);
    } else {
      mobileQuery.addListener(handleBreakpointChange); /* Safari <14 fallback */
    }

    handleBreakpointChange(); /* run once on load */
  }

  /* ── Init ─────────────────────────────────────────────────────────────── */
  function init() {
    initFadeIn();
    initCountUp();
    initRevealImg();
    initHeaderTheme();
    initMobileStickyCtaIdle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
